import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export function deleteApiTokenRequestConfig(scimConfigId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'DELETE',
    endpoint: `scimConfigurations/${scimConfigId}/apiToken`,
    serverWideRequest: false
  };
}



export function callDeleteApiTokenForScimConfiguration(scimConfigId: string): Promise<IResult> {
  return makeJsonRestApiRequest<void, IResult>({
    config: deleteApiTokenRequestConfig(scimConfigId),
    request: null
  });
}